import Button from "@/comps/button"

const ApplyNow = () => {
  return <Button text="txt_apply_now"></Button>
}

export default ApplyNow
